import React from "react";
import styled from "styled-components";
import { Input, FormGroup, Label } from "reactstrap";

import { FormError } from "../../Cards/FormCard";
import { ModalTogglerStyled } from "../../Modals/TermsAndConditionsModal";

const TermsText = styled.span`
  font-size: 0.875rem;
`;

const TermsAndConditionsInput = ({
  onChange,
  error,
  onTermsConditionsClick,
}) => {
  const handleOnClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onTermsConditionsClick();
  }

  const handleOnChange = (e) => {
    onChange(e);
  }

  return (
    <FormGroup>
      <Label check>
        <Input
          type="checkbox"
          onChange={handleOnChange}
        />{" "}
        <TermsText>
          I acknowledge that I have read and understand the{" "}
          <ModalTogglerStyled onClick={handleOnClick}>
            terms and conditions
          </ModalTogglerStyled>{" "}
          associated with this service.{" "}
        </TermsText>
      </Label>
      {error && (
        <FormError>You must agree with our Terms and Conditions</FormError>
      )}
    </FormGroup>
  )
};

export default TermsAndConditionsInput;
